import React from 'react';
import { translate } from '../../Services/translation';
import constants from '../../constants';

const StockLogin = ({ isProductPage, }) => {
  return (
    <div className='stock__login'>
      {constants.loginUrl && (
        <a className='stock__login__link' href={constants.loginUrl}>{translate('configstock.instock')}</a>
      )}
      {!isProductPage && constants.becomeCustomerLink && (
        <a href={constants.becomeCustomerLink} className='button button--orange'>
          {translate('configstock.becomecustomer')}
        </a>
      )}
    </div>
  );
};

export default StockLogin;
